var React = require('react');

function ArrowRounded (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.75 12L20.25 12","stroke":"#5C5BEE","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M13.5 5.25L20.25 12L13.5 18.75","stroke":"#5C5BEE","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowRounded.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowRounded;

ArrowRounded.default = ArrowRounded;
